// extracted by mini-css-extract-plugin
export var fadeIn = "styles-module--fadeIn--PSGNN";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--Re2KP";
export var gutter = "styles-module--gutter--XUgFk";
export var gutterLight = "styles-module--gutterLight--08KkX";
export var scaleUp = "styles-module--scaleUp--1Rnx2";
export var slideIn = "styles-module--slideIn--kdPHS";